import React, { useState } from 'react';
import { Card, List, Button, Form } from "tabler-react";
import Select from 'react-select';
import PostObject from '../../lib/postObject';

const NotificationAllUserModal = ({ recordId, closeMainModal }) => {
    const [saveLoading, toggleSaveLoading] = useState(false)
    const [form, changeFormInput] = useState({
        notificationId: null,
        roles: [],
    });
    const globeroles = [{ label: 'Shopper', value: 'Shopper' }, { label: 'Traveller', value: 'Traveller' }]
    const { loading: usersLoading } = globeroles;

    const submitForm = () => {
        let tempUsers = [];
        form.roles.forEach((element) => {
            tempUsers.push(element.value);
        });

        const notification = {
            notificationId: recordId,
            roles: tempUsers
        }

        toggleSaveLoading(true)
        PostObject('notifications/notifyByUserRole', notification).then(() => {
            toggleSaveLoading(false)
            closeMainModal()
        });
    }
    
    return (
        <Card>
            <Card.Header>
                <Card.Title>Send  Notification By Role</Card.Title>
                <Card.Options>
                    <Button
                        size="sm"
                        icon="x"
                        onClick={() => closeMainModal()}
                    />
                </Card.Options>
            </Card.Header>
            <Card.Body>
                <Form>
                    <Form.FieldSet>
                        <Form.Label>roles: </Form.Label>
                        <List.GroupItem>
                            <Select
                                value={form.owner}
                                options={globeroles && globeroles.map(user => {
                                    return ({ label: user.label, value: user.value });
                                })}
                                isSearchable
                                isMulti
                                placeholder="roles"
                                isLoading={usersLoading}
                                onChange={(e) => { changeFormInput({ ...form, roles: e }); }}
                            />
                        </List.GroupItem>
                    </Form.FieldSet>
                </Form>
            </Card.Body>
            <Card.Footer>
                <div style={{ textAlign: 'right' }}>
                    <Button
                        color="primary"
                        size="sm"
                        className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
                        type="submit"
                        onClick={submitForm}
                        disabled={saveLoading}
                    >
                        Save
                    </Button>
                    <Button
                        color="secondary"
                        size="sm"
                        className="ml-2"
                        onClick={() => closeMainModal()}
                        disabled={saveLoading}
                    >
                        cancel
                    </Button>
                </div>
            </Card.Footer>
        </Card>
    )
}

export default NotificationAllUserModal;